import { type ICompanyMatchQuery } from 'application/querySchemas/ICompanyMatchQuery';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type ICompanyMatchListClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/ICompanyMatchListClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class CompanyMatchQuery implements ICompanyMatchQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyMatchListClient')
        public readonly companyMatchListClient: ICompanyMatchListClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.companyMatchListClient.get({
            token: this.companyUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
